// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"e30ddce4","450":"82d9ecab"}[chunkId] + ".chunk.js";
};